import { useMemo } from 'react';
import { getRbacByPath } from './rbac.entity';
export default function useRbacController(route) {
    var path = route !== null && route !== void 0 ? route : window.location.pathname;
    var rbac = useMemo(function () { return getRbacByPath(path); }, [path]);
    return rbac;
}
